/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface ActionConfig
 */
export interface ActionConfig {
  /**
   * Selected Custom ivr id for vm drop
   * @type {number | null}
   * @memberof ActionConfig
   */
  customIvrDetailsId?: number | null;
  /**
   * delay in seconds to fire the action
   * @type {number}
   * @memberof ActionConfig
   */
  delay?: number;
  /**
   * Flow.id of a nested flow action
   * @type {string | null}
   * @memberof ActionConfig
   */
  flowId?: string | null;
  /**
   * max times to repeat condition
   * @type {number | null}
   * @memberof ActionConfig
   */
  maxAttempts?: number | null;
}

/**
 * Check if a given object implements the ActionConfig interface.
 */
export function instanceOfActionConfig(value: object): value is ActionConfig {
  return true;
}

export function ActionConfigFromJSON(json: any): ActionConfig {
  return ActionConfigFromJSONTyped(json, false);
}

export function ActionConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActionConfig {
  if (json == null) {
    return json;
  }
  return {
    customIvrDetailsId:
      json['custom_ivr_details_id'] == null
        ? undefined
        : json['custom_ivr_details_id'],
    delay: json['delay'] == null ? undefined : json['delay'],
    flowId: json['flow_id'] == null ? undefined : json['flow_id'],
    maxAttempts:
      json['max_attempts'] == null ? undefined : json['max_attempts'],
  };
}

export function ActionConfigToJSON(value?: ActionConfig | null): any {
  if (value == null) {
    return value;
  }
  return {
    custom_ivr_details_id: value['customIvrDetailsId'],
    delay: value['delay'],
    flow_id: value['flowId'],
    max_attempts: value['maxAttempts'],
  };
}
